import { createStore } from "vuex";

import article from "./modules/article"
import user from "./modules/user"
import certificate from "./modules/certificate"
import apply from "./modules/apply"
import exam from './modules/exam'

export default createStore({
  state: {
    status:"/index",
  },
  getters:{
    status:(state)=>state.status
  },
  mutations: {
    STATUS(state,data){
      state.status = data
    }
  },
  actions: {
    set_status({commit},data){
      commit('STATUS',data)
    }
  },
  modules: {
    article,
    user,
    certificate,
    apply,
    exam
  }
});
